module.exports = __webpack_public_path__ + "img/symbol_7.ab7757f2.png";